import React from "react";
import { motion } from "framer-motion";

const Pill = ({ children }) => (
  <span className="px-3 py-1 rounded-full text-xs glass text-[#CFAEFF] font-medium">
    {children}
  </span>
);

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative section-pad"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 grid lg:grid-cols-12 gap-14 items-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.7 }}
          className="lg:col-span-7"
        >
          <div className="text-[#27C6FF] uppercase tracking-[0.3em] text-xs mb-5 font-heading">
            About DietDotIn
          </div>
          <h2 className="font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl text-white leading-[1.05]">
            Holistic transformation,
            <br />
            <span className="gradient-text">engineered for life.</span>
          </h2>
          <p className="mt-7 text-[#D8CCFF] text-base md:text-lg max-w-2xl leading-relaxed font-body">
            DietDotIn isn&rsquo;t another diet plan. It&rsquo;s a
            clinically-led wellness practice built on four pillars — nutrition
            science, mental wellness, physical strength, and sustainable
            lifestyle discipline. We blend evidence with empathy to design
            transformations that endure even when life gets busy.
          </p>

          <div className="mt-8 flex flex-wrap gap-2.5" data-testid="about-pills">
            <Pill>Mental Wellness</Pill>
            <Pill>Clinical Nutrition</Pill>
            <Pill>Fitness Coaching</Pill>
            <Pill>Habit Identity</Pill>
            <Pill>Sleep & Stress</Pill>
            <Pill>Sustainable Lifestyle</Pill>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.8 }}
          className="lg:col-span-5"
        >
          <div className="grid grid-cols-2 gap-4">
            {[
              { k: "98%", v: "Client Adherence" },
              { k: "3–6", v: "Months to Real Change" },
              { k: "0", v: "Crash Diets, Ever" },
              { k: "1:1", v: "Personalised Coaching" },
            ].map((s) => (
              <div
                key={s.v}
                className="glass rounded-2xl p-6 hover:neon-aqua transition-shadow duration-500"
                data-testid={`about-stat-${s.v.replace(/\s+/g, "-").toLowerCase()}`}
              >
                <div className="font-display font-bold text-3xl text-white">
                  {s.k}
                </div>
                <div className="text-[#CFAEFF] text-sm mt-1">{s.v}</div>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
